import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-328">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50" onClick={onClose} data-id="element-329" />

          <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.3
      }} className="fixed inset-4 md:inset-10 lg:inset-x-auto lg:top-10 lg:bottom-10 lg:w-[800px] lg:mx-auto bg-navy-900 border border-teal-500/20 rounded-2xl z-50 flex flex-col overflow-hidden" data-id="element-330">
            <div className="flex items-center justify-between px-6 py-4 border-b border-teal-500/10 flex-shrink-0" data-id="element-331">
              <h2 className="text-xl font-display font-bold text-white" data-id="element-332">
                Términos y Condiciones
              </h2>
              <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-navy-800 transition-colors text-gray-400 hover:text-white" aria-label="Cerrar" data-id="element-333">
                <X size={20} data-id="element-334" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-6" data-id="element-335">
              <div className="prose prose-invert max-w-none space-y-8 text-gray-300 leading-relaxed" data-id="element-336">
                <p data-id="element-337">
                  El presente documento establece los términos y condiciones
                  aplicables al uso de la plataforma TruID.
                </p>

                <section data-id="element-338">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-339">
                    1. ACCESO A LA CUENTA
                  </h3>
                  <ul className="list-disc list-inside space-y-2" data-id="element-340">
                    <li data-id="element-341">
                      Cada cuenta o usuario creado es uso personal e
                      intransferible.
                    </li>
                    <li data-id="element-342">
                      Podrá acceder a ella cualquier persona natural mayor de
                      edad que complete el formulario de registro
                      correspondiente.
                    </li>
                    <li data-id="element-343">
                      El uso de la Cuenta implica la aceptación plena de estos
                      términos y condiciones.
                    </li>
                  </ul>
                </section>

                <section data-id="element-344">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-345">
                    2. RESPONSABILIDAD DE LA PLATAFORMA
                  </h3>
                  <ul className="list-disc list-inside space-y-2" data-id="element-346">
                    <li data-id="element-347">
                      TruID administra información para la validación segura de
                      identidades digitales, y permite que múltiples plataformas
                      externas se conecten con el fin de poder realizar
                      validaciones de identidad u otros servicios, de acuerdo a
                      la aprobación explícita de cada usuario. Sin embargo,
                      TruID no tiene ni asume ninguna responsabilidad sobre los
                      productos, servicios o problema de cualquier tipo
                      relacionados con dichas plataformas.
                    </li>
                    <li data-id="element-348">
                      En caso de cualquier inconveniente o reclamo relacionado
                      con plataformas que usan a TruID como método de validación
                      e identificación de usuarios o para cualquier otra
                      función, deberá realizar su reclamo respectivo a dicha
                      plataforma, no teniendo TruID ninguna responsabilidad
                      sobre funciones, productos o servicios sobre plataformas
                      interconectadas con TruID.
                    </li>
                  </ul>
                </section>

                <section data-id="element-349">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-350">
                    3. VIGENCIA Y MODIFICACIONES
                  </h3>
                  <ul className="list-disc list-inside space-y-2" data-id="element-351">
                    <li data-id="element-352">
                      La vigencia de la cuenta es de uso indefinido, salvo que
                      el usuario renuncie expresamente a su uso.
                    </li>
                    <li data-id="element-353">
                      TruID se reserva el derecho de modificar, suspender o
                      cancelar las cuentas de usuarios, informando oportunamente
                      a los usuarios a través de sus canales oficiales.
                    </li>
                  </ul>
                </section>

                <section data-id="element-354">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-355">
                    4. PROTECCIÓN DE DATOS PERSONALES
                  </h3>
                  <ul className="list-disc list-inside space-y-2" data-id="element-356">
                    <li data-id="element-357">
                      Al afiliarse, el usuario autoriza el tratamiento de sus
                      datos personales conforme a la legislación vigente,
                      exclusivamente para fines informativos y promocionales
                      relacionados con el programa.
                    </li>
                    <li data-id="element-358">
                      Los datos no serán compartidos con terceros sin
                      consentimiento del titular, salvo requerimiento legal.
                      Puede ver más detalles en el documento de nuestras
                      Políticas de Privacidad y Protección de Datos Personales.
                    </li>
                  </ul>
                </section>

                <section data-id="element-359">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-360">
                    5. USO INDEBIDO Y CANCELACIÓN
                  </h3>
                  <ul className="list-disc list-inside space-y-2" data-id="element-361">
                    <li data-id="element-362">
                      El uso fraudulento, indebido o contrario a estos términos
                      puede dar lugar a la anulación inmediata de la cuenta y la
                      pérdida de sus beneficios.
                    </li>
                    <li data-id="element-363">
                      La organización podrá suspender o eliminar una cuenta en
                      caso de mal uso sin necesidad de notificación previa.
                    </li>
                  </ul>
                </section>

                <section data-id="element-364">
                  <h3 className="text-lg font-display font-semibold text-white mb-3" data-id="element-365">
                    6. VIGENCIA
                  </h3>
                  <p data-id="element-366">
                    La vigencia de estos Términos y Condiciones de Uso es desde
                    el 12 de septiembre de 2025 y permanecerá vigente hasta que
                    exista una nueva versión que la reemplace.
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}